/**
 * Consent categories and cookie parameters.
 *
 * POLICY_VERSION and SCHEMA_VERSION are deliberately plain literals rather than
 * `import.meta.env` values: they are properties of the shipped content, not of
 * the environment, and must be identical in dev, staging and production. The
 * Django settings CONSENT_POLICY_VERSION / CONSENT_SCHEMA_VERSION are the
 * authoritative copies; tests/apps/consent/test_policy_version_parity.py keeps
 * the two in step.
 *
 * Bump POLICY_VERSION whenever the cookie policy changes materially — doing so
 * invalidates every stored consent and re-prompts all visitors.
 * Bump SCHEMA_VERSION when the shape of the stored payload changes.
 */

export const CATEGORIES = {
  NECESSARY: 'necessary',
  ANALYTICS: 'analytics',
  MARKETING: 'marketing',
};

export const OPT_IN_CATEGORIES = [CATEGORIES.ANALYTICS, CATEGORIES.MARKETING];

export const POLICY_VERSION = '2026-07-28';
export const SCHEMA_VERSION = 1;

export const CONSENT_COOKIE_NAME = 'sol_consent';

// Six months — CNIL's recommended consent validity window.
export const CONSENT_MAX_AGE_SECONDS = 60 * 60 * 24 * 182;

export const CONSENT_ACTIONS = {
  GRANTED: 'granted',
  UPDATED: 'updated',
  WITHDRAWN: 'withdrawn',
};

// First-party vendor cookies we can reach and delete on withdrawal. Cookies set
// on clarity.ms / bing.com are third-party and unreachable from this origin.
export const VENDOR_COOKIES = ['_clck', '_clsk'];
